import React from "react";
import {Paragraph, Title} from "../TermsText";

const LiabilitySection = () => {
  return (
    <>
      <Title>{"7. Limitation of Liability."}</Title>

      <Paragraph variant="primary">
        {"IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR CONSEQUENTIAL, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR ENHANCED DAMAGES, LOST PROFITS OR REVENUES OR DIMINUTION IN VALUE, ARISING OUT OF, OR RELATING TO, AND/OR IN CONNECTION WITH ANY BREACH OF THESE TERMS, REGARDLESS OF (A) WHETHER SUCH DAMAGES WERE FORESEEABLE, (B) WHETHER OR NOT WE WERE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND (C) THE LEGAL OR EQUITABLE THEORY (CONTRACT, TORT OR OTHERWISE) UPON WHICH THE CLAIM IS BASED."}
      </Paragraph>

      <Paragraph variant="primary">
        {"OUR SOLE AND ENTIRE MAXIMUM LIABILITY, FOR ANY REASON, AND YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY CAUSE WHATSOEVER, SHALL BE LIMITED TO THE ACTUAL AMOUNT PAID BY YOU FOR THE PRODUCTS AND SERVICES YOU HAVE ORDERED THROUGH OUR SITE."}
      </Paragraph>

      <Paragraph>
        {"The limitation of liability set forth above shall: (i) only apply to the extent permitted by law and (ii)/ not apply to (A) liability resulting from our willful misconduct and (B) death or bodily injury resulting from our acts or omissions."}
      </Paragraph>
    </>
  );
};

export default React.memo(LiabilitySection);
